export const SET_LIST = 'SET_LIST';
export const SET_MAP = 'SET_MAP';
